import React from 'react';
import {Helmet} from "react-helmet";
//import { useNavigate } from 'react-router-dom';
import { Box, Container } from '@mui/material';
//import logo from '../../assets/images/logo_new.png';
//import arrow_down from "../../assets/images/arrow-down-01.png"
//import rentdirect from "../../assets/images/rentdirect.png";
import rend_id from "./assets/images/rent-id-logo.svg";
//import rend_id2 from "../../assets/images/rend_id2.png";
import RentIdanimation from './RentIdanimation'
import AIheader from '../../pages/RentAI/AIheader';
import RentIdPage from "./RentIdPage/RentIdPage";
// import PopularTopics from './PopularTopics/PopularTopics';
import BetaForm from '../BetaForm';
import Footer from '../Footer/Footer';
//import { useLocation } from 'react-router-dom';
const RentId2 = () => {
//const navigate = useNavigate();

//const location = useLocation();
//console.log(location.pathname);




  return (
   <>
      <Helmet>
        <title>RentID | Risk Assessment and Vetting Tools for Car Rentals</title>
        <meta name="twitter:title" content="RentID | Risk Assessment and Vetting Tools for Car Rentals" />
        <meta name="description" content="Protect your car rental fleet with RentID's advanced AI-driven identity verification, risk assessment, and compliance tools. Enhance trust, safety, and operational efficiency with real-time guest verification, insurance validation, and risk management dashboards." />
        <meta name="twitter:description" content="RentID empowers car rental operators with advanced risk assessment and verification tools. Protect your fleet with real-time guest verification, insurance validation, and risk management dashboards." />
        <meta property="og:description" content="Discover RentID's AI-powered tools for car rental operators. From real-time identity verification to DriverIQ risk scoring and a National BlockList Database, RentID helps you protect your fleet and optimize operations with smarter decision-making." />
        <meta name="keywords" content="Commercial Auto Insurance, Rental Fleet Insurance, Guest Protection Plans, National Roadside Assistance, Digital Claims Management, On-Demand Coverages, Vehicle Protection, Rentid Insurance Solutions, Fleet Compliance, Automated Insurance" />
        <meta property="og:url" content="https://www.rentid.io/rent-id" />
        <link rel="canonical" href="https://www.rentid.io/rent-id" />
      </Helmet>
     <Box
        sx={{
          background: 'linear-gradient(180deg, #082C72 0%, #001132 55%, #000000 100%)',
          height: '100vh',
          display: 'none',
          width: '100%',
        }}
      >
        <Container>
        {/* <RentHeader /> */}


{/* Banner section start from here */}

        <section className='bannerRentIdMain'>
            <div className='row'>
                <div className='col-lg-5'>
                    <div className='bannerIdLeft'>
                    <img alt="Rentid" src={rend_id}></img>
                    <small>ADVANCED TRUST AND SAFETY TOOLS</small>
                      <h1>Outsmart risk with built-in <span>security</span> <span>measures.</span> </h1>
                      <p>Use data-driven decision-making to protect your account, vehicles, and future earnings. 
                        You alone control who gets the keys.</p>
                    </div>
                </div>

                <div className='col-lg-7'>
                  <div className='bannerIdRight'>
                      {/* <img src={rend_id2} alt=''/> */}
                  <RentIdanimation />
                  </div>
                </div>
            </div>
        </section>
        
        </Container>
      </Box>
      {/* {location.pathname === '/rentid1' && ( */}
          <>
            {/* <Rentidheader /> */}
            <AIheader/>
            <div className="rd-legacy"><RentIdPage/></div>
            <BetaForm />       
            {/* <PopularTopics /> */}
            <Footer />
          </>
        {/* )} */}
   </>
  )
}

export default RentId2
